import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { Suspense } from 'react';
import { ErrorBoundary } from './components/error-boundary';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Initialize theme immediately to prevent flash
const initializeTheme = () => {
    // Remove any existing theme classes first
    document.documentElement.classList.remove('dark', 'light');

    const storedTheme = localStorage.getItem('theme') || 'system';
    let effectiveTheme: string;

    if (storedTheme === 'system') {
        // Check system preference
        effectiveTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    } else {
        effectiveTheme = storedTheme;
    }
    effectiveTheme = 'light'; // Force light theme for now
    document.documentElement.classList.add(effectiveTheme);
    document.documentElement.style.colorScheme = effectiveTheme;
};

// Initialize theme immediately
//initializeTheme();

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    resolve: (name) =>
        resolvePageComponent(
            `./pages/${name}.tsx`,
            import.meta.glob('./pages/**/*.tsx'),
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <ErrorBoundary>
                <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
                    <App {...props} />
                </Suspense>
            </ErrorBoundary>
        );
    },
    progress: {
        color: '#4B5563',
    },
});
